'use client';
import {
  usePreviousSignupStep,
  useSignupStep,
} from '@/app/(auth)/signup/components/signupStep/SignupStepContext';
import React from 'react';
import { Button } from '@common/bw-ui/ui/button';
import { Spinner } from '@common/bw-ui/ui/spinner';
import { ArrowRightIcon } from '@common/bw-ui/icons';
import { cn } from '@common/bw-ui/lib/utils';
import { StepNavigationLinks } from './StepNavigationLinks';

/** The design's ghost treatment for a Continue button that can't be pressed yet */
export const disabledContinueClasses =
  'tw:disabled:opacity-100 tw:disabled:bg-none tw:disabled:bg-transparent tw:disabled:border tw:disabled:border-[#dbdedb] tw:disabled:text-[#dbdedb] tw:disabled:shadow-none';

export function StepNavigation(props: {
  preventNext?: boolean;
  extra?: Record<string, string>;
  nextLabel?: string;
}) {
  const { next, prev, isValid, isSubmittingPrev, isSubmittingNext } = useSignupStep();
  const { handleSubmit: handleSubmitPrevious } = usePreviousSignupStep();
  const canGoForward = isValid && !props.preventNext;

  const handleSubmitNext = (e: React.FormEvent) => {
    e.preventDefault();
    next?.(props.extra);
  };

  return (
    <>
      <div className="tw:flex tw:w-full tw:items-center tw:gap-2">
        {prev ? (
          <Button
            id="previous"
            type="button"
            variant="outline"
            onClick={handleSubmitPrevious}
            disabled={isSubmittingPrev}
            className="tw:h-12 tw:rounded-[10px] tw:border-foreground tw:bg-white tw:px-5 tw:text-base tw:font-medium tw:text-foreground">
            {isSubmittingPrev && <Spinner className="tw:size-4" />}
            Back
          </Button>
        ) : null}
        {next ? (
          <Button
            id="next"
            type="submit"
            variant="success"
            onClick={handleSubmitNext}
            disabled={!canGoForward || isSubmittingNext}
            className={cn(
              'tw:h-12 tw:flex-1 tw:rounded-[10px] tw:text-base tw:font-medium [&_svg]:tw:size-6',
              disabledContinueClasses,
            )}>
            {isSubmittingNext && <Spinner className="tw:size-4" />}
            {props.nextLabel ?? 'Continue'}
            <ArrowRightIcon className="tw:size-6" aria-hidden="true" />
          </Button>
        ) : (
          <div className="tw:flex-1" />
        )}
      </div>
      <StepNavigationLinks />
    </>
  );
}
